<template>
  <div>
    <section class="tables">
      <div class="row">
        <Breadcrumb :breadcrumbs="breadcrumbs" />

        <div class="col-lg-12">
          <vue-bootstrap4-table
            :rows="rows"
            :columns="columns"
            :config="config"
            @on-change-query="onChangeQuery"
            :total-rows="total_rows"
            :classes="classes"
            :show-loader="showLoader"
          >

            <!-- ACTION DROPDOWN -->
            <template slot="action" slot-scope="props">
              <b-dropdown
                size="xs"
                variant="primary"
                text="Select"
                right
              >
                <b-dropdown-item @click="viewRow(props.row)">
                  <i class="mdi mdi-eye"></i>
                  View Data
                </b-dropdown-item>

                <b-dropdown-item @click="approveRow(props.row._id)">
                  <i class="mdi mdi-check"></i>
                  Approve Request
                </b-dropdown-item>

                <b-dropdown-item @click="rejectRow(props.row._id)">
                  <i class="mdi mdi-close"></i>
                  Reject Request
                </b-dropdown-item>
              </b-dropdown>
            </template>



            <!-- PICKUP STOP BUTTON SLOT -->
            <template slot="user_pickup_stop" slot-scope="props">
              <button
                v-if="props.row.user_pickup_stop"
                class="btn btn-primary btn-sm"
                @click="openMap(props.row.user_pickup_stop)"
              >
                View
              </button>
              <span v-else>-</span>
            </template>

            <!-- DROP STOP BUTTON SLOT -->
            <template slot="user_drop_stop" slot-scope="props">
              <button
                v-if="props.row.user_drop_stop"
                class="btn btn-primary btn-sm"
                @click="openMap(props.row.user_drop_stop)"
              >
                View
              </button>
              <span v-else>-</span>
            </template>

          </vue-bootstrap4-table>

          <!-- Modal -->
          <b-modal
            ref="myModalRefUser"
            :title="title"
            size="xl"
            :ok-title="modaloktitle"
            @hidden="hideModal"
            @ok="handleOk"
          >
            <span v-if="modalView">
              <RequestRouteView :modalData="modalData" />
            </span>
          </b-modal>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { requestRouteService } from "../../../services";
import Breadcrumb from "../../../components/breadcrumb";
import VueBootstrap4Table from "vue-bootstrap4-table";
import RequestRouteView from "./models/view.vue";

export default {
  name: "RequestRoute",
  data() {
    return {
      breadcrumbs: {
        title: "Request Routes",
        b1: "Manage Requests",
        b2: "Request Routes",
        b3: "Index",
        link: false,
        name: "Request Routes",
      },
      columns: [
        { label: "Route", name: "routeId_title", sort: true },
        { label: "Customer", name: "userId_fullname", sort: true },
        { label: "Email", name: "userId_email", sort: true },
        { label: "Phone", name: "userId_phone", sort: true },

        // Slots handle these
        { label: "Pick Up stop", name: "user_pickup_stop", sort: false },
        { label: "Drop stop", name: "user_drop_stop", sort: false },

        { label: "Action", name: "action", sort: false },
      ],
      rows: [],
      config: {
        server_mode: true,
        loaderText: "Loading...",
        pagination: true,
        global_search: { placeholder: "Search requests", visibility: true },
        per_page_options: [10, 25, 50],
      },
      classes: { table: "table-bordered table-striped" },
      queryParams: {
        sort: [],
        filters: [],
        global_search: "",
        per_page: 10,
        page: 1,
      },
      total_rows: 0,
      showLoader: false,
      modalView: false,
      modalData: {},
      title: "",
      modaloktitle: "Ok",
    };
  },
  components: { VueBootstrap4Table, Breadcrumb, RequestRouteView },

  methods: {
    openMap(coords) {
      if (!coords) return;
      const url = `https://www.google.com/maps?q=${coords[1]},${coords[0]}`;
      window.open(url, "_blank");
    },

    viewRow(data) {
      // console.log("Clicked row:", data); // debugging
      this.modalData = { ...data };      // ensure reactivity
      // console.log("Modal data set to:", this.modalData); // debugging
      this.title = "Request Route Details";
      this.modalView = true;

      // ensure modal content updates before showing
      this.$nextTick(() => {
        this.$refs.myModalRefUser.show();
      });
    },
    hideModal() {
      this.modalView = false;
    },
    handleOk() {
      this.$refs.myModalRefUser.hide();
      this.modalView = false;
    },
    async loadItems() {
      this.showLoader = true;

      const response = await requestRouteService.getAll(); 
      // response is already an array
      
      this.rows = requestRouteService.transform(response);
      // console.log("response for data: ", response);
      // console.log("Loaded Request Routes:", this.rows);

      this.total_rows = this.rows.length;
      this.showLoader = false;
    },

    async approveRow(id) {
      const response = await requestRouteService.approve(id);
      if (response.status) {
          this.$toast.open({
            message: response.message,
            type: "success",
            position: "top-right",
            duration: 2000,
          });   
      } 
      else {
          this.$toast.open({
            message: "Failed to approved request",
            type: "success",
            position: "top-right",
            duration: 2000,
          });
      }
      this.loadItems();
    },
    async rejectRow(id) {
      const response = await requestRouteService.reject(id);
      if (response.status) {
          this.$toast.open({
            message: response.message,
            type: "success",
            position: "top-right",
            duration: 2000,
          });   
      } 
      else {
          this.$toast.open({
            message: "Failed to reject request",
            type: "success",
            position: "top-right",
            duration: 2000,
          });
      }
      this.loadItems();
    },
    onChangeQuery(params) {
      this.queryParams = params;
      this.loadItems();
    },
  },

  mounted() {
    this.loadItems();
  },
};
</script>

<style scoped></style>
